import { createFileRoute } from "@tanstack/react-router";
import { KsefConfigPage } from "@/features/ksef/ksef-config-page";
import { ensureAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/ksef")({
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: KsefConfigPage,
});
